<form class="form-boxes m-0 p-0" [formGroup]="affiliateDetailsForm">

     <!-- Empresa -->
     <div class="row mb-2">
          <div class="col-10">
               <h2 class="font-weight-bold d-flex"><img class="ic-mid mr-2" src="assets/img/ic_user.svg">{{ 'affiliatedetails.Tus datos' | translate }}</h2>
               <h5>{{ 'affiliatedetails.Información de contacto y notificaciones' | translate }}</h5>
               <hr class="w-10 float-left mt-2 mb-4">
          </div>
          <div class="col-2 text-right">
               <a class="cursor-pointer" (click)="toggleEdition()">
                    <img class="ic-mid mr-2" src="{{ isDisabled ? 'assets/img/ic_edit.svg' : 'assets/img/ic_edit-disabled.svg'}}">
               </a>
          </div>
     </div>

     <div class="row mb-3">
          <div class="col-12 col-md-6">
               <div class="field pb-2">
                    <input formControlName="companyName" type="text" name="companyName" id="companyName" placeholder="{{ 'affiliatedetails.Nombre de la compañía' | translate }}" value="">
                    <label for="companyName">{{ 'affiliatedetails.Nombre de la compañía' | translate }}</label>
               </div>
               <app-feedback [formGroup]="affiliateDetailsForm" field="companyName" validator="required" feedback="{{ 'affiliatedetails.Nombre de empresa requerido' | translate }}" [refresh]="refreshValidators"></app-feedback>
               <app-feedback [formGroup]="affiliateDetailsForm" field="companyName" validator="maxlength" feedback="{{ 'createtourdetails.Texto demasiado largo' | translate }}" [refresh]="refreshValidators"></app-feedback>
          </div>
          <div class="col-12 col-md-6">
             <div class="field pb-2">
                 <input formControlName="address" type="text" name="address" id="address" placeholder="{{ 'affiliatedetails.Dirección' | translate }}" value="">
                 <label for="address">{{ 'affiliatedetails.Dirección' | translate }}</label>
             </div>
             <app-feedback [formGroup]="affiliateDetailsForm" field="address" validator="required" feedback="{{ 'affiliatedetails.Dirección requerida' | translate }}" [refresh]="refreshValidators"></app-feedback>
         </div>
          <div class="col-12 col-md-6">
               <div class="field pb-2">
                    <select formControlName="country" name="country" (change)="onCountrySelected()">
                         <option [ngValue]="null">{{ 'createtourdetails.Selecciona la opción' | translate }}</option>
                         <option *ngFor="let country of countries" value="{{ country.id }}">{{ country.name }}</option>
                    </select>
                    <label for="country">{{ 'affiliatedetails.País' | translate }}</label>
               </div>
               <app-feedback [formGroup]="affiliateDetailsForm" field="country" validator="required" feedback="{{ 'affiliatedetails.País requerido' | translate }}" [refresh]="refreshValidators"></app-feedback>
          </div>
          <div class="col-12 col-md-6">
               <div class="field pb-2">
                    <select formControlName="city" name="city">
                         <option [ngValue]="null">{{ 'createtourdetails.Selecciona la opción' | translate }}</option>
                         <option *ngFor="let city of cities" value="{{ city.id }}">{{ city.name }}</option>
                    </select>
                    <label for="city">{{ 'affiliatedetails.Ciudad' | translate }}</label>
               </div>
               <app-feedback [formGroup]="affiliateDetailsForm" field="city" validator="required" feedback="{{ 'affiliatedetails.Ciudad requerida' | translate }}" [refresh]="refreshValidators"></app-feedback>
          </div>

          <div class="col-12 col-md-6">
             <div class="field pb-2">
                  <select formControlName="businessDocumentType" name="businessDocumentType">
                     <option value="">{{ 'affiliatedetails.Selecciona la opción' | translate }}</option>
                     <option value="CIF">{{ 'providerpayment.CIF' | translate }}</option>
                     <option value="VAT">{{ 'providerpayment.VAT' | translate }}</option>
                     <option value="Pasport">{{ 'affiliatedetails.Pasaporte' | translate }}</option>
                  </select>
                 <label for="businessDocumentType">{{ 'affiliatedetails.Tipo de documento' | translate }}</label>
             </div>
             <app-feedback [formGroup]="affiliateDetailsForm" field="businessDocumentType" validator="required" feedback="{{ 'affiliatedetails.Tipo de documento requerido' | translate }}" [refresh]="refreshValidators"></app-feedback>
         </div>

         <div class="col-12 col-md-6">
            <div class="field pb-2">
                <input formControlName="businessDocument" type="text" name="businessDocument" id="businessDocument" placeholder="{{ 'providerpayment.Número de documento' | translate }}" value="">
                <label for="businessDocument">{{ 'affiliatedetails.Número de documento' | translate }}</label>
            </div>
            <app-feedback [formGroup]="affiliateDetailsForm" field="businessDocument" validator="required" feedback="{{ 'affiliatedetails.Número de documento requerido' | translate }}" [refresh]="refreshValidators"></app-feedback>
        </div>

         <div class="col-12 col-md-6">
              <div class="field pb-2">
                   <input formControlName="phone" type="phone" name="phone" id="phone" placeholder="{{ 'affiliatedetails.Teléfono' | translate }}" value="">
                   <label for="phone">{{ 'affiliatedetails.Teléfono' | translate }}</label>
              </div>
              <app-feedback [formGroup]="affiliateDetailsForm" field="phone" validator="required" feedback="{{ 'affiliatedetails.Teléfono requerido' | translate }}" [refresh]="refreshValidators"></app-feedback>
              <app-feedback [formGroup]="affiliateDetailsForm" field="phone" validator="maxlength" feedback="{{ 'createtourdetails.Texto demasiado largo' | translate }}" [refresh]="refreshValidators"></app-feedback>
         </div>


         <div class="col-12 col-md-6 d-flex mt-4 pt-3">
            <div class="checkbox-custom mr-2">
                <input formControlName="businessZeroVat" type="checkbox" name="businessZeroVat" id="businessZeroVat" value="">
                <div class="checkbox-custom-visible"></div>
            </div>
            <label for="businessZeroVat">{{ 'affiliatedetails.Exento de IVA' | translate }}</label>
        </div>


     </div>

     <div class="row mb-5 pb-5">
          <div class="col-12">
               <div class="field pb-0">
                    <label>{{ 'affiliate.Website' | translate }}</label>
               </div>
          </div>
          <ng-container formArrayName="websites">
               <div class="col-12 col-md-6" *ngFor="let website of websites.controls; let websiteIndex = index" [formGroup]="website">
                    <div class="field pb-2">
                         <input (keyup)="onWebsiteChanged($event, websiteIndex)" formControlName="url" type="text" id="{{ 'url' + websiteIndex }}" name="{{ 'url' + websiteIndex }}" placeholder="{{ 'affiliate.Website' | translate }}" value="">
                    </div>
                    <app-feedback [formGroup]="website" field="url" validator="maxlength" feedback="{{ 'affiliatedetails.Texto demasiado largo' | translate }}" [refresh]="refreshValidators"></app-feedback>
                    <app-feedback [formGroup]="website" field="url" validator="pattern" feedback="{{ 'affiliatedetails.Indica una URL válida' | translate }}" [refresh]="refreshValidators"></app-feedback>
               </div>
          </ng-container>

          <div class="col-3 col-md-6 col-lg-3 mb-4">
               <a (click)="onAddWebsite()" class="btn w-md-50 w-100 btn-tertiary mb-3 mb-sm-0 white-color px-0 px-sm-auto"  [ngClass]="{'disabled': isDisabled}">
                    <img class="ic-mid" src="assets/img/ic_add-white.svg">
               </a>
          </div>
     </div>

     <div class="row mb-5 pb-5">
          <div class="col-12 col-md-6 offset-md-6 col-lg-4 offset-lg-8">
               <input (click)="saveDetails()" type="submit" value="{{ 'affiliatedetails.Guardar datos' | translate }}" class="btn btn-full-width btn-primary mb-3 mb-sm-0" [disabled]="isDisabled" />
          </div>
     </div>
</form>

<app-message-panel [preloading]="false"></app-message-panel>